const showdHokkaido = () => {
  document.getElementById('hokkaido__section').style.display = 'block';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showTohoku = () => {
  document.getElementById('tohoku__section').style.display = 'block';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showKanto = () => {
  document.getElementById('kanto__section').style.display = 'block';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showHokuriku = () => {
  document.getElementById('hokuriku__section').style.display = 'block';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showTokai = () => {
  document.getElementById('tokai__section').style.display = 'block';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showKinki = () => {
  document.getElementById('kinki__section').style.display = 'block';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showTyugoku = () => {
  document.getElementById('tyugoku__section').style.display = 'block';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showShikoku = () => {
  document.getElementById('shikoku__section').style.display = 'block';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
  document.getElementById('kyushu__section').style.display = 'none';
};

const showKyushu = () => {
  document.getElementById('kyushu__section').style.display = 'block';
  document.getElementById('shikoku__section').style.display = 'none';
  document.getElementById('tyugoku__section').style.display = 'none';
  document.getElementById('kinki__section').style.display = 'none';
  document.getElementById('tokai__section').style.display = 'none';
  document.getElementById('hokuriku__section').style.display = 'none';
  document.getElementById('kanto__section').style.display = 'none';
  document.getElementById('tohoku__section').style.display = 'none';
  document.getElementById('hokkaido__section').style.display = 'none';
};
